import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { NavLink } from "react-router-dom"



const SearchResults = () => {

const search = useSelector(state => state.search)
console.log(search)



    

    return (
        <div >
            <div class="title">Resultados de la búsqueda:</div>
            <div class="searchcontainer">
            {search.length != 0? search.map(e => e.t=="game" ? <NavLink to={`/lmi/games`}><a href={`#game${e.id}`}><div class="searchCard">
                <img class="searchImg" src={e.image} alt="" />
                <div class="searchText">
                <div class="title">{e.name}</div>
                <div class="searchDesc">{e.description}</div>
                </div>
            </div></a></NavLink> : <NavLink to={`/lmi/${e.t}/${e.id}`}><div class="searchCard">
                <img class="searchImg" src={e.image} alt="" />
                <div class="searchText">
                <div class="title">{e.name}</div>
                <div class="searchDesc">{e.description}</div>
                </div>
            </div></NavLink>)
            :
            <div class="title">No se encontraron resultados para tu búsqueda</div>
            }
            </div>
        </div>
    )
}

export default SearchResults 